import { IProjectDocumentStatus, Project } from '../types';
import { getFormattedNumber, getFullMonthYearFromDate } from './formatting';
import { PROJECT_OPERATIONAL_STATUS, TECHNOLOGY } from './enums/generic.enum';

function stringCamelCase(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

export function generateProjectDescription(project: Project | IProjectDocumentStatus): string {
  if (!project) {
    return '';
  }

  let capacityDetails = '';
  switch (project.TECHNOLOGY) {
    case TECHNOLOGY.SOLAR:
      capacityDetails = `${getFormattedNumber(project.MEGAWATT_DC)} MW DC / ${getFormattedNumber(project.MEGAWATT_AC)} MW AC`;
      break;
    case TECHNOLOGY.WIND:
      capacityDetails = `${getFormattedNumber(project.MEGAWATT_AC)} MW AC`;
      break;
    default:
      capacityDetails = 'Technology not supported';
      break;
  }

  let projectDescription = '';

  projectDescription =
    project.NAME +
    ' is a ' +
    capacityDetails +
    ' nameplate capacity ' +
    stringCamelCase(project.TECHNOLOGY) +
    ' generation ' +
    (project.PROJECT_OPERATIONAL_STATUS === PROJECT_OPERATIONAL_STATUS.NEW_BUILD
      ? 'development'
      : 'operating') +
    ' project located in ' +
    project.COUNTY_NAME +
    ', ' +
    project.STATE_NAME +
    '. This ' +
    (project.PROJECT_OPERATIONAL_STATUS === PROJECT_OPERATIONAL_STATUS.NEW_BUILD
      ? 'project will interconnect into the ' +
        project.ISO +
        ' grid and is anticipated to reach COD in ' +
        getFullMonthYearFromDate(project.GUARANTEED_COD) +
        '.'
      : project.ISO +
        ' interconnected project  started operations in ' +
        getFullMonthYearFromDate(project.COD) +
        '.');

  return projectDescription;
}
